module.exports = __webpack_public_path__ + "static/img/page5.d1e5972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/page5.png
// module id = DS67
// module chunks = 2